<div class="back-btn hidelg mt-15 ml-15">
  <a href="javascript:history.back()">
    <img src="assets/images/icons/back-black-arrow.png" alt="">
  </a>
</div>

<section class="enquiry-wrp mb-4">
  <div class="container">
    <div class="w-35 uk-margin-auto">
      <div class="key-highlight-pricing">
        <div class="inquiry-banner">
          <h3>You miss answers to 100% of the questions you don't ask!</h3>
          <p>Super happy you reached out to us and we promise you’ll be too!</p>
        </div>
        <h4>Enquiry Now</h4>
        <!-- SIGNUP -->
        <div class="border-form-input">
          <form #enquiryForm="ngForm" method="post" *ngIf="!enquirySuccessful">
            <div class="form-group">
              <div class="uk-inline">
                  <span class="uk-form-icon">
                   <!-- <img src="assets/images/icons/people.png" alt="">-->
                   <i class="fa fa-user"></i>
                  </span>
                <input class="uk-input" placeholder="Full Name" type="text" name="full_name" required="required"
                       minlength="4" [(ngModel)]="enquiryPayLoad.full_name" #enquiryFullName="ngModel">
              </div>

              <span class="error" *ngIf="enquiryForm.submitted && enquiryForm.invalid">
                <div *ngIf="enquiryFullName.errors?.required">
                  This field cannot be empty.
                </div>
              </span>

            </div>
            <div class="form-group">
              <div class="uk-inline">
                    <span class="uk-form-icon">
                      <!--<img src="assets/images/icons/mail.png" alt="">-->
                      <i class="fa fa-envelope"></i>
                    </span>
                <input class="uk-input" placeholder="Email Id" type="email" name="email" required="required"
                       minlength="4" [(ngModel)]="enquiryPayLoad.email" #enquiryEmail="ngModel">
              </div>

              <span class="error" *ngIf="enquiryForm.submitted && enquiryForm.invalid">
                <div *ngIf="enquiryEmail.errors?.required">
                  This field cannot be empty.
                </div>

                  <div *ngIf="enquiryEmail.errors?.invalid">
                  Email is invalid.
                </div>

              </span>

            </div>

            <div class="form-group">
              <div class="uk-inline">
                  <span class="uk-form-icon">
                    <!--<img src="assets/images/icons/call.png" alt="">-->
                    <i class="fa fa-phone"></i>
                  </span>
                <input class="uk-input" placeholder="Enter Mobile No." type="tel" name="mobile_number"
                       required="required" minlength="10" [(ngModel)]="enquiryPayLoad.mobile_number"
                       #enquiryMobileNumber="ngModel">
              </div>

              <span class="error" *ngIf="enquiryForm.submitted && enquiryForm.invalid">
                <div *ngIf="enquiryMobileNumber.errors?.required">
                  This field cannot be empty.
                </div>

                <div *ngIf="enquiryMobileNumber.errors?.minlength">
                  Mobile number must be 10 digits.
                </div>
              </span>

            </div>
            <div class="form-group custom-radio mb-1">
              <span>Are you planning an Occasion?</span>
              <label><input class="uk-radio" type="radio" name="radio2" value="Yes"
                            checked="{{enquiryPayLoad.occasion==='Yes'?'checked':''}}"> Yes</label>
              <label><input class="uk-radio" type="radio" name="radio2" value="No"
                            checked="{{enquiryPayLoad.occasion==='No'?'checked':''}}"> No</label>
            </div>

            <div class="form-group">

              <div class="uk-inline">
                                      <span class="uk-form-icon cursor-pointer">
                                        <img src="assets/images/icons/calendar.png" alt="">
                                      </span>
                <input class="uk-input" placeholder="Select your preferred dates" type="date"
                       name="occasion_date" min="{{minDate | date:'yyyy-MM-dd'}}"
                       max="{{maxDate | date:'yyyy-MM-dd'}}" required="required" [(ngModel)]="enquiryPayLoad.occasion_date"
                       #enquiryOccasionDate="ngModel">
              </div>

              <span class="error" *ngIf="enquiryForm.submitted && enquiryForm.invalid">
                <div *ngIf="enquiryOccasionDate.errors?.required">
                  This field cannot be empty.
                </div>
              </span>

            </div>


            <div class="form-group mt-2">
              <button type="submit" class="btn-yellow" (click)="submitEnquiry()">
                Enquiry Now
              </button>
              <small *ngIf="enquiryResponseReceived">{{enquiryErrorMessage}}</small>
            </div>
          </form>

          <ng-container *ngIf="enquirySuccessful">
            <div class="thankyou-box">
              <img src="assets/images/icons/right-green.png" alt="">
              <h6>Thank you {{enquiryPayLoad.full_name}}</h6>
              <p>for your response. We will reach <br> out to you shortly!</p>
            </div>
          </ng-container>

        </div>


        <!-- border-form-input -->
      </div>

    </div>
    <!--w-30-->
  </div>
</section>
